module.exports = __webpack_public_path__ + "img/share.b200ce58.png";